// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2s4i6","header":"Messages_header__2kNs4"};